angular.module('wbDirectives').directive 'fieldSelect', ->
  scope: false
  restrict: 'C'
  link: ($scope, $el) ->
    $select = $('select', $el)
    classes = null
    $scope.$watch ->
      newClasses = $select.attr('class')
      return if newClasses is classes
      $el.removeClass(classes)
      $el.addClass(newClasses)
      classes = newClasses
